// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Oe0O","rightAdornment":"Header_rightAdornment__15JQR"};